import Config from "../Config";

export default class LanguageBloc {

  //Get user latest selected language
  static getSelectedLanguage() {
    let selectedLanguage = sessionStorage.getItem(Config.cache.languageKey);
    return selectedLanguage ? selectedLanguage : Config.locale.en;
  }

  //Return string with selected language
  static getTextForLocale(string) {
    let selectedLanguage = this.getSelectedLanguage()
    return selectedLanguage === 'EN' ? string.en : string.bm;
  }

    //Get error title by error code
    static getErrorTitleByCode(errorCode) {
      return this.getTextByCode(Config.labelPrefix.errorTitle + errorCode);
    }
  
    //Get error desc by error code
    static getErrorDescByCode(errorCode) {
      return this.getTextByCode(Config.labelPrefix.errorDesc + errorCode);
    }
  
    //use this and remove hardcoded "getTextByCode" function when API label data are populated
    static getTextByCode(code, specificLang) {
      let labels = this.getLabelsByCode(code);
      let lang = specificLang || this.getSelectedLanguage();
            
      let text = labels[lang];
      //if(!text) return Config.error.labelNotFound;
      if(!text) return code;          
      return text;
    }
}